module.exports = __webpack_public_path__ + "img/Introduction to MS-Office.5d1c3ff1.svg";